













import Vue from "vue";
import { required, integer } from "vuelidate/lib/validators";
import dialog from "@/common/mixins/dialog";
import LineEditorForm from "../components/LineEditorForm.vue";
import { LineCreateForm } from "../forms/LineCreateForm";
import { Shop } from "../../shop/models/Shop";
export default Vue.extend({
  mixins: [dialog],
  components: {
    LineEditorForm
  },
  validations: {
    lineCreateForm: {
      shop: { required },
      shopName: { required },
      lineKey: { required },
      mcApiKey: { required },
      mcSecretkey: { required }
    }
  },
  data() {
    const shops: Shop[] = [];
    const lineCreateForm: LineCreateForm = {
      shopName: "",
      lineKey: "",
      mcApiKey: "",
      mcSecretkey: "",
      autoApprove: false
    };
    return { lineCreateForm, shops };
  },
  async created() {
    await Promise.all([this.getShops()]);
  },
  methods: {
    async getShops() {
      try {
        const { data } = await (this as any).$dep.shopUseCase.getShops({
          perPage: 9999
        });
        this.shops = data;
      } catch (error) {
        console.log(error.response);
      }
    },
    goToLineViewPage() {
      this.$router.push({ name: "LineViewPage" });
    },
    async createLine() {
      try {
        await (this as any).$dep.lineUseCase.createShopLine(
          this.lineCreateForm
        );
        if (await (this as any).alertSuccess("Success", "เพิ่ม Line สำเร็จ")) {
          this.goToLineViewPage();
        }
      } catch (error) {
        if (error.response && error.response.status === 400) {
          (this as any).alertError("Error", error.response.data.message);
        } else {
          process.env.NODE_ENV === "production"
            ? (this as any).alertError("Error", "ไม่สามารถสร้าง Line ได้")
            : (this as any).alertError("Error", error);
        }
      }
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      const isConfirmed = await (this as any).alertConfirm(
        "Confirm to add Line",
        "คุณต้องการเพิ่ม Line หรือไม่ ?"
      );
      if (isConfirmed) {
        await this.createLine();
      }
    },
    clear() {
      this.$v.$reset();
      this.lineCreateForm = {
        shopName: "",
        lineKey: "",
        mcApiKey: "",
        mcSecretkey: "",
        autoApprove: false
      };
    }
  }
});
